/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import { ferryFetch } from "@ecom-alliance/libs";
import * as api from "../../api";
import * as image from "../../common/image";
import * as video from "../../common/video";
import * as oec_affiliate_creator_marketplace_api from "./oec_affiliate_creator_marketplace_api";
import * as quota from "../data/quota";
import * as brand_deal from "../data/brand_deal";
export { api, image, video, oec_affiliate_creator_marketplace_api, quota, brand_deal };
import { method, headers, queryStringify } from "../../_util";
export var ProductQueryType = {
  PQT_UNKNOWN: 0,
  PQT_PRODUCT_ID: 1,
  PQT_PRODUCT_NAME: 2
};
export var ProductSortField = {
  PST_PRICE: 1,
  PST_ITEM_SOLD: 2,
  PST_STOCK: 3
};
export var InvitationProductStatus = {
  ProductStatus_UNSPECIFIED: 0,
  ProductStatus_LIVE: 1,
  ProductStatus_OUT_OF_STOCK: 2,
  ProductStatus_SELLER_DEACTIVATE: 3,
  ProductStatus_PLATFORM_DEACTIVATE: 4,
  ProductStatus_GNE_REJECT: 5,
  ProductStatus_SOLD_ONLY_IN_TOKO: 7
};
export var CheckType = {
  ALL_PRODUCT_2_ALL_CREATOR: 1,
  PRODUCT_2_ALL_CREATOR: 2,
  ALL_PRODUCT_2_CREATOR: 3,
  FREE_SAMPLE_REQUEST: 4
};
export var SampleRequestStatus = {
  SampleRequest_DEFAULT: 0,
  SampleRequest_Pending: 1,
  SampleRequest_AwaitingShipment: 2,
  SampleRequest_AwaitingCollection: 3,
  SampleRequest_Shipped: 4,
  SampleRequest_ContentPending: 5
};
export var InvitationGroupStatus = {
  INVITATION_GROUP_STATUS_UNSPECIFIED: 0,
  INVITATION_GROUP_STATUS_LIVE: 1,
  INVITATION_GROUP_STATUS_EXPIRING: 2,
  INVITATION_GROUP_STATUS_DELETING: 3,
  INVITATION_GROUP_STATUS_ENDED: 4,
  INVITATION_GROUP_STATUS_VALID: 5
};
export var QueryType = {
  SEARCH_KEY_UNSPECIFIED: 0,
  SEARCH_BY_PRODUCT_ID: 1,
  SEARCH_BY_PRODUCT_NAME: 2,
  SEARCH_BY_INVITATION_ID: 3,
  SEARCH_BY_INVITATION_NAME: 4,
  SEARCH_BY_CREATOR_NAME: 5,
  SEARCH_BY_CREATOR_ID: 6
};
export var InvitationGroupAcceptStatus = {
  INVITATION_GROUP_UN_KNOW: 0,
  INVITATION_GROUP_UN_ACCEPT: 1,
  INVITATION_GROUP_ACCEPT: 2,
  INVITATION_GROUP_ALL: 3
};
export var InvitationGroupFreeSampleStatus = {
  INVITATION_GROUP_FREE_SAMPLE_DEFAULT: 0,
  INVITATION_GROUP_HAS_FREE_SAMPLE: 1
};
export var AffiliateCreatorType = {
  AFFILIATE_CREATOR_TYPE_UNSPECIFIED: 0,
  AFFILIATE_CREATOR_TYPE_NORMAL: 1,
  AFFILIATE_CREATOR_TYPE_SELF_SOLD: 2
};
export var CreatorSearchType = {
  CREATOR_SEARCH_TYPE_NAME: 1,
  CREATOR_SEARCH_TYPE_TT_UID: 2,
  CREATOR_SEARCH_TYPE_OEC_ID: 3
};
export var AddShowcaseFilterType = {
  AddShowcaseFilterType_ALL: 1,
  AddShowcaseFilterType_Added: 2,
  AddShowcaseFilterType_NotAdded: 3
};
export var InvitationGroupCreatorStatus = {
  INVITATION_GROUP_CREATOR_STATUS_NORMAL: 1,
  INVITATION_GROUP_CREATOR_STATUS_DELETING: 2,
  INVITATION_GROUP_CREATOR_STATUS_DELETED: 3
};
export var InvitationGroupProductStatus = {
  INVITATION_GROUP_PRODUCT_STATUS_NORMAL: 1,
  INVITATION_GROUP_PRODUCT_STATUS_DELETING: 2,
  INVITATION_GROUP_PRODUCT_STATUS_DELETED: 3
};
export var SendLimitReason = {
  SendLimitReason_Reach24HMax: 1,
  SendLimitReason_ReachEffectiveMax: 2
};
export var OfficialShopLabel = {
  OfficialShopLabel_None: 1,
  OfficialShopLabel_BlueV: 2,
  OfficialShopLabel_Mall: 3
};
export var NotInvitableType = {
  INVITED: 1,
  REACHED_MAX_CREATOR_SIZE: 2,
  MISSING_INFORMATION: 3,
  EFFECTIVE_FLASH_SALE: 4
};
export var BrandAbnormalTag = {
  NEED_PAYMENT: 1,
  PRODUCT_UNAVAILABLE: 2,
  PRODUCT_OOS: 3
};
export var FlashSaleStatus = {
  FlashSaleStatus_Unknown: 0,
  FlashSaleStatus_NotStart: 1,
  FlashSaleStatus_InProgress: 2,
  FlashSaleStatus_Ended: 3,
  FlashSaleStatus_Canceled: 4
};
export var ContentType = {
  ContentType_NoPrefer: 0,
  ContentType_Video: 1,
  ContentType_Live: 2
};
export var GroupType = {
  GROUP_TYPE_NORMAL: 1,
  GROUP_TYPE_PLAN: 2,
  GROUP_TYPE_PEARL: 3,
  GROUP_TYPE_CAMPAIGN: 4,
  GROUP_TYPE_OPENAPI: 5,
  GROUP_TYPE_BRAND: 6
};
export var InvitationBrandTask = {
  INVITATION_BRAND_TASK_PENDING_PAYMENT: 1,
  INVITATION_BRAND_TASK_SAMPLE_SHIPMENT: 2,
  INVITATION_BRAND_TASK_CONTENT_REVIEW: 3,
  INVITATION_BRAND_TASK_CONTENT_PUBLISH: 4
};
export var InvitationMilestoneType = {
  MilestoneType_Invitation_Create: 1,
  MilestoneType_Invitation_Send: 2,
  MilestoneType_Invitation_Send_Success: 3,
  MilestoneType_Invitation_Send_Fail: 4,
  MilestoneType_Invitation_Creator_Acceptance: 5,
  MilestoneType_Invitation_Creator_Acceptance_Ongoing: 6,
  MilestoneType_Invitation_Creator_Accepted: 7,
  MilestoneType_Invitation_Creator_Reject: 8,
  MilestoneType_Invitation_Creator_No_Action: 9,
  MilestoneType_Seller_Pay_Ongoing: 10,
  MilestoneType_Seller_Pay_Success: 11,
  MilestoneType_Seller_Pay_Fail: 12,
  MilestoneType_Creator_Upload_Has_Hard_Deadline: 13,
  MilestoneType_Creator_Upload_No_Hard_Deadline: 14,
  MilestoneType_Creator_Upload_Has_Hard_Deadline_Ongoing: 15,
  MilestoneType_Creator_Upload_No_Hard_Deadline_Ongoing: 16,
  MilestoneType_Creator_Upload_Success: 17,
  MilestoneType_Creator_Upload_Fail: 18,
  MilestoneType_Platform_Auditing_Has_Seller_Audit: 19,
  MilestoneType_Platform_Auditing_No_Seller_Audit: 20,
  MilestoneType_Platform_Auditing_Ongoing_Has_Seller_Audit: 21,
  MilestoneType_Platform_Auditing_Ongoing_No_Seller_Audit: 22,
  MilestoneType_Platform_Auditing_Success: 23,
  MilestoneType_Platform_Auditing_Fail: 24,
  MilestoneType_Seller_Auditing: 25,
  MilestoneType_Seller_Auditing_Ongoing: 26,
  MilestoneType_Seller_Auditing_Success: 27,
  MilestoneType_Seller_Auditing_Fail: 28,
  MilestoneType_Seller_Auditing_Multi_Refuse_Fail: 29,
  MilestoneType_Creator_Re_Upload: 30,
  MilestoneType_Creator_Re_Upload_Ongoing: 31,
  MilestoneType_Creator_Re_Upload_Success: 32,
  MilestoneType_Creator_Re_Upload_No_Action: 33,
  MilestoneType_Seller_Post_Has_Seller_Auditing: 34,
  MilestoneType_Seller_Post_No_Seller_Auditing: 35,
  MilestoneType_Seller_Post_Has_Seller_Auditing_Ongoing: 36,
  MilestoneType_Seller_Post_No_Seller_Auditing_Ongoing: 37,
  MilestoneType_Seller_Post_Success: 38,
  MilestoneType_Seller_Post_Fail: 39,
  MilestoneType_Cancel: 40
};
export var InvitationBrandStatus = {
  INVITATION_BRAND_STATUS_WAIT_SELLER_PAY: 1,
  INVITATION_BRAND_STATUS_WAIT_CREATOR_ACCEPTANCE: 2,
  INVITATION_BRAND_STATUS_CREATOR_ACCEPTED: 3,
  INVITATION_BRAND_STATUS_WAIT_SELLER_REPAY: 4,
  INVITATION_BRAND_STATUS_WAIT_CREATOR_UPLOAD: 5,
  INVITATION_BRAND_STATUS_PLATFORM_AUDITING: 6,
  INVITATION_BRAND_STATUS_SELLER_AUDITING: 7,
  INVITATION_BRAND_STATUS_WAIT_CREATOR_REUPLOAD: 8,
  INVITATION_BRAND_STATUS_APPROVED: 9,
  INVITATION_BRAND_STATUS_WAIT_CREATOR_SETTLE: 10,
  INVITATION_BRAND_STATUS_CREATOR_SETTLING: 11,
  INVITATION_BRAND_STATUS_WAIT_SELLER_POST: 12,
  INVITATION_BRAND_STATUS_CLOSED: 98,
  INVITATION_BRAND_STATUS_COMPLETED: 99
};
export var InvitationBrandCreatorProgress = {
  Wait_Creator_Accept: 1,
  Pending_payment: 2,
  Pending_Creator_Upload_Video: 3,
  Awaiting_Platform_Review: 4,
  Awaiting_Seller_Review: 5,
  Pending_Creators_Upload_Revised_Video: 6,
  Video_To_Be_Published: 7,
  Video_Posted: 8,
  Cancelled: 9,
  Creator_Rejected: 10
};
export var InvitationBrandCreatorSampleStatus = {
  Not_Provide_Samples: 1,
  Waiting_Creator_To_Apply: 2,
  Pending_Sample_Shipment: 3,
  Pending_Receiving_Sample: 4,
  Sample_Received: 5
};
export var InvitationPairEffectiveStatus = {
  IPES_UNSPECIFIED: 0,
  IPES_EFFECTIVE_ALL: 1,
  IPES_EFFECTIVE_PARTIALLY: 2,
  IPES_EFFECTIVE_NONE: 3
};
export var AuditResultType = {
  AuditResultType_Approve: 1,
  AuditResultType_Reject: 2,
  AuditResultType_Reupload: 3
};
export var ProductFailedReason = {
  FLASH_SALE_OVERLAP: 1,
  PRICE_INVALID: 2,
  BUY_MORE_SAVE_MORE_OVERLAP: 3,
  BUNDLE_DEAL_OVERLAP: 4,
  ACTIVITY_OVERLAP: 5,
  PRODUCT_SOLD_OUT: 6,
  CATEGORY_FORBIDDEN: 7,
  CONSECUTIVE_LIVE_FLASH_SALE_NOT_MET_STIPULATED_BREAK_INTERVAL: 8,
  NON_SELLABLE_PRODUCT: 9,
  NO_AFFILIATE_PLAN: 10,
  RESERVE_STOCK_FAILED: 11,
  INVALID_DISCOUNT_RATE_TOO_HIGH: 12,
  INVALID_DISCOUNT_RATE_TOO_LOW: 13,
  PURCHASE_LIMIT_MORE_THAN_OPEN_STOCK: 14,
  PRODUCT_OWNER_WITHDREW_ACTIVITY: 15
};
export var ConflictType = {
  ConflictType_NON_FLATFEE: 1,
  ConflictType_A1: 2,
  ConflictType_PRIVATE: 3
};
export var CreatorCooperateType = {
  CREATOR_ALL: 1,
  CREATOR_ADD_PRODUCT: 2,
  CREATOR_POST_CONTENT: 3
};
export var PredictionScene = {
  InvitationCreate: 1,
  InvitationUpdate: 2,
  CreatorMarketplaceAdd: 3,
  CRMAdd: 4
};
export var IrrelevantType = {
  SellerAndCreatorCategoryNotMatch: 1,
  CreatorSideLowExposureRate: 2,
  CreatorSideLowResponseRate: 3,
  LowModelScore: 4
};
export var AffiliateInvitationApi = /*#__PURE__*/function () {
  function AffiliateInvitationApi(uriPrefix) {
    this.uriPrefix = typeof uriPrefix !== "undefined" ? uriPrefix : "";
  }
  var _proto = AffiliateInvitationApi.prototype;
  _proto.AffiliateInvitationGroupProductSearch = function AffiliateInvitationGroupProductSearch(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/search/product";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationGroupCreatorSearch = function AffiliateInvitationGroupCreatorSearch(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/search/creator";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateLatestInvitationGroupBasicInfo = function AffiliateLatestInvitationGroupBasicInfo(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/latest_basic_info";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationGroupRateLimitInfo = function AffiliateInvitationGroupRateLimitInfo(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/rate_limit_info";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationGroupSearch = function AffiliateInvitationGroupSearch(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/search";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCountInvitation = function AffiliateCountInvitation(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/count";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationConflictCheck = function AffiliateInvitationConflictCheck(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/conflict_check";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationGroupCreate = function AffiliateInvitationGroupCreate(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/create";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateBrandDealInvitationGroupCreate = function AffiliateBrandDealInvitationGroupCreate(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/brand_deal/create";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationGroupDetail = function AffiliateInvitationGroupDetail(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/detail";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateBrandDealInvitationGroupDetail = function AffiliateBrandDealInvitationGroupDetail(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/brand_deal/detail";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationGroupUpdate = function AffiliateInvitationGroupUpdate(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateBrandDealInvitationGroupUpdate = function AffiliateBrandDealInvitationGroupUpdate(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/brand_deal/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationGroupReUpdate = function AffiliateInvitationGroupReUpdate(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/re_update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationGroupAddCreator = function AffiliateInvitationGroupAddCreator(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/creators_add";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationGroupTerminate = function AffiliateInvitationGroupTerminate(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/terminate";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationGroupProductCreatorRelation = function AffiliateInvitationGroupProductCreatorRelation(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/product_creator_relation";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationGroupCreatorPromotionDetail = function AffiliateInvitationGroupCreatorPromotionDetail(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/creator_promotion_detail";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationGroupCreatorVideoList = function AffiliateInvitationGroupCreatorVideoList(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/creator_video_list";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliatePreviousInvitationUseStatus = function AffiliatePreviousInvitationUseStatus(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/previous_invitation/use_status";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateGetProductsInfo = function AffiliateGetProductsInfo(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation/products_info";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateGenShortUrl = function AffiliateGenShortUrl(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/share/short_url";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateGetLongUrl = function AffiliateGetLongUrl(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/share/long_url/" + request.url_code;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.AffiliateShopInfo = function AffiliateShopInfo(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/shop/info";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.AffiliateSensitiveTextCheck = function AffiliateSensitiveTextCheck(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/sensitive_text_check";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.InvitationGroupInvitationLimit = function InvitationGroupInvitationLimit(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/invitation/limit";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.CheckShopValidForCampaignInvitation = function CheckShopValidForCampaignInvitation(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/campaign/shop_validate";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCampaignInvitationCreatorSet = function GetCampaignInvitationCreatorSet(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/campaign/creator_set" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCampaignInvitationCriteria = function GetCampaignInvitationCriteria(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/campaign/criteria" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetInvitationGroupCreators = function GetInvitationGroupCreators(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/detail/creators" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetSellerCampaignBanner = function GetSellerCampaignBanner(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/campaign/banner";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetInvitationGeneralInfo = function GetInvitationGeneralInfo(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/general/config";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.AffiliateSellerQuotaInfo = function AffiliateSellerQuotaInfo(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/quota/info";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateSellerCreatorConnectCheck = function AffiliateSellerCreatorConnectCheck(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/quota/connection/check";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateSellerGetConnectedCreators = function AffiliateSellerGetConnectedCreators(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/quota/connected_creators";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreatorRelevancyPrediction = function CreatorRelevancyPrediction(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/creator/relevancy/prediction";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetSellerPromotionConfig = function GetSellerPromotionConfig(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation_group/promotion/configs";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateBrandDealInvitationCreatorDetail = function AffiliateBrandDealInvitationCreatorDetail(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation/brand_deal/creator/detail";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateBrandDealInvitationVideoList = function AffiliateBrandDealInvitationVideoList(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation/brand_deal/creator/video_list";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateBrandDealInvitationVideoEdit = function AffiliateBrandDealInvitationVideoEdit(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation/brand_deal/creator/video/edit";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateBrandDealInvitationVideoApprove = function AffiliateBrandDealInvitationVideoApprove(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation/brand_deal/creator/video/approve";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateBrandDealInvitationVideoPost = function AffiliateBrandDealInvitationVideoPost(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation/brand_deal/creator/video/post";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateBrandDealInvitationPay = function AffiliateBrandDealInvitationPay(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation/brand_deal/pay";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateBrandDealInvitationPayStatus = function AffiliateBrandDealInvitationPayStatus(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/invitation/brand_deal/pay/status";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  return AffiliateInvitationApi;
}();
export var affiliateInvitationApiClient = new AffiliateInvitationApi();